import { useFetch } from './useFetch'
import type { VenueDTO } from '../types'

export function useVenue(id: string) {
  const { data: venue, isLoading, error } =
    useFetch<VenueDTO | null>(`/v1/venues/${id}`, null)
  return { venue, isLoading, error }
}
